module.exports = __webpack_public_path__ + "img/imageninicio.41fa7904.jpg";